<template>
    <section ref='filtersWrapper' :class="['parametric-filters', {'is-open': isFilterOpen}]">
        <div ref='filtersInner' class="parametric-filters__wrapper">
            <div @click="$emit('close')" class="parametric-filters__close">
                <ButtonClose />
            </div>

            <form
                :class="['parametric-filters__form', {'is-processing': isProc}]"
                ref="form"
                @change="change"
                @reset.prevent="reset">

                <div v-if="isEstateFlat" class="parametric-filters__group">
                    <div v-if="building" class="parametric-filters__group">
                        <div class="parametric-filters__group-label">Выберите секцию</div>
                        <SingleSelect :options="building" name="building" />
                    </div>

                    <div class="parametric-filters__group-label">
                        Комнатность
                    </div>
                    <ul class="parametric-filters__rooms-list">
                        <li v-for="item in filters.room" :key="item.id">
                            <ButtonCheckbox
                                :name="`room[${item.id}]`"
                                :checked="item.checked"
                                :disabled="item.disabled"
                                :value="item.title"
                            />
                        </li>
                    </ul>
                </div>

                <div v-else class="parametric-filters__group">
                    <Select
                        :building="building"
                        @selectric-select="selectrichange($event)"
                        ref='buildingWrapper'
                        :modify="'parametric-filters__select'"
                    />
                    <div class="parametric-filters__button-wrapper">
                        <button
                            type="button"
                            class="button parametric-filters__button-gen-plan"
                            @click.prevent="$emit('openModal')"
                        >
                            <Mark />
                            <span>Выбрать корпус на генплане</span>
                        </button>
                    </div>
                </div>

                <div v-if="!hiddenPrices" class="parametric-filters__group">
                    <div class="parametric-filters__group-label">
                        Стоимость {{ isEstateFlat ? 'квартиры' : 'помещения' }}, руб.
                    </div>
                    <Slider
                        :name="'price'"
                        :to="sliders.price.to"
                        :from="sliders.price.from"
                        :modify="'test'"
                        ref="sliderPrice"/>
                </div>
                <div class="parametric-filters__group">
                    <div class="parametric-filters__group-label">Площадь, м²</div>
                    <Slider
                        :name="'area'"
                        :to="sliders.area.to"
                        :from="sliders.area.from"
                        ref="sliderArea"/>
                </div>

                <div v-if="isEstateFlat" class="parametric-filters__group">
                    <div class="parametric-filters__group-label">Этаж</div>
                    <Slider
                        :name="'floors'"
                        :to="sliders.floors.to"
                        :from="sliders.floors.from"
                        ref="sliderFloors"/>
                </div>

                <div class="parametric-filters__group">
                    <div class="parametric-filters__group-options">
                        <ul class="parametric-filters__options-list">
                            <li v-for="item in filters.delivery" :key="item.id">
                                <ButtonCheckbox
                                    :modify="'button-checkbox_theme_label'"
                                    :name="`delivery[${item.id}]`"
                                    :checked="item.checked"
                                    :disabled="item.disabled"
                                    :value="item.title"
                                />
                            </li>
                        </ul>
                    </div>

                    <div v-if="isEstateFlat" class="parametric-filters__group-options">
                        <ul class="parametric-filters__options-list">
                            <li v-for="item in filters.option" :key="item.id">
                                <ButtonCheckbox
                                    :modify="'button-checkbox_theme_label'"
                                    :name="`option[${item.id}]`"
                                    :checked="item.checked"
                                    :disabled="item.disabled"
                                    :value="item.title"
                                />
                            </li>
                        </ul>
                    </div>
                </div>

                <div class="parametric-filters__group">
                    <button class="parametric-filters__reset" type="reset">
                        <div class="parametric-filters__reset-text">Сбросить параметры</div>
                        <ResetIcon />
                    </button>
                </div>
            </form>
        </div>

        <button
            ref="buttonUp"
            :class="['button', 'button_theme_black', 'button_theme_icon', 'parametric-filters__up',
                {'is-static': buttonUpIsStatic},
                {'is-fixed': buttonUpIsFixed}]"
            @click="scrollToTop">
            Фильтровать
            <UpIcon />
        </button>
    </section>
</template>

<script>
import {mapActions, mapGetters} from 'vuex';
import ButtonCheckbox from 'components/button-checkbox/ButtonCheckbox.vue';
import ButtonClose from 'components/button-close/ButtonClose.vue';
import {debounce} from 'throttle-debounce';
import initSliders from 'components/range-slider/config/param';
import Mark from '../svg-media/mark.vue';
import Observer from 'common/scripts/observer';
import ResetIcon from '../svg-media/reset.vue';
import ScrollBy from 'components/scrollBy';
import Select from 'components/forms/select/select-vue.vue';
import SingleSelect from 'components/forms/many-select/many-select.vue';
import Slider from 'components/range-slider/range-slider.vue';
import UpIcon from '../svg-media/up.vue';
import Utils from 'common/scripts/utils';

const observer = new Observer();
const scrollBy = new ScrollBy();

export default {
    data() {
        return {
            buttonUpIsStatic: false,
            buttonUpIsFixed : false
        };
    },

    props: ['isFilterOpen'],

    components: {
        ButtonCheckbox,
        ButtonClose,
        Mark,
        Select,
        SingleSelect,
        Slider,
        ResetIcon,
        UpIcon
    },

    computed: {
        ...mapGetters({
            isReady     : 'GET_IS_READY',
            isProc      : 'GET_IS_PROCESSING',
            sliders     : 'GET_SLIDERS',
            building    : 'GET_BUILDING',
            filters     : 'GET_FILTERS',
            page        : 'GET_PAGE',
            estateType  : 'GET_ESTATETYPE',
            hiddenPrices: 'GET_HIDDENPRICES'
        }),

        isEstateFlat() {
            return this.estateType === 1;
        }
    },

    watch: {
        isReady() {
            this.$nextTick(() => {
                initSliders(this.$refs, this.sliders);
                this.initFilter({form: this.$refs.form});
                this.buildingList = {...this.building};
            });
        },

        sliders() {
            this.$nextTick(() => {
                observer.publish('parametricfilterUpdate');
                this.updateFilter();
            });
        },

        page() {
            this.changeStateButtonUp();
        },

        isFilterOpen() {
            if (this.isFilterOpen) {
                observer.publish('parametricfilterOpen', this.$refs.filtersWrapper);
                Utils.bodyFixed(this.$el);
            } else {
                observer.publish('parametricfilterClose', this.$refs.filtersWrapper);
                Utils.bodyStatic();
            }
        }
    },

    mounted() {
        this.bindEvents();
        this.subscribes();
        this.changeStateButtonUp();

        scrollBy.init();
    },

    methods: {
        ...mapActions(['initFilter', 'changeFilter', 'resetFilter', 'updateFilter', 'updateBuildings']),

        subscribes() {
            observer.subscribe('rangesliderFinish', () => {
                this.change();
            });
        },

        bindEvents() {
            window.addEventListener('scroll', debounce(10, () => {
                this.changeStateButtonUp();
            }));
        },

        change() {
            const body = {
                type: 'filter',
                form: this.$refs.form
            };

            this.changeFilter(body);
        },

        reset() {
            $('#buildingSelection')
                .find('option:first-child')
                .prop('selected', true)
                .end()
                .trigger('chosen:updated')
                .change(() => {
                    this.$emit('selectChange');
                });
            this.resetFilter({type: 'reset'});

            observer.publish('resetManySelect');
        },

        selectrichange() {
            this.change();
        },

        changeStateButtonUp() {
            if (Utils.isBreakpoint(320, 670)) {
                return;
            }

            const isFilterViewport = Utils.isInViewport(this.$refs.filtersInner);
            const currentScroll = window.scrollY + window.innerHeight;
            const parametricHeight = this.$parent.$el.offsetHeight;
            const filterHeight = this.$refs.filtersInner.offsetHeight + this.$refs.filtersInner.offsetTop;

            if (filterHeight === parametricHeight) {
                return;
            }

            if (!isFilterViewport && (parametricHeight > currentScroll)) {
                this.buttonUpIsStatic = false;
                this.buttonUpIsFixed = true;
            }

            if (isFilterViewport || !(parametricHeight > currentScroll)) {
                this.buttonUpIsStatic = true;
                this.buttonUpIsFixed = false;
            }

            if (isFilterViewport) {
                this.buttonUpIsStatic = false;
                this.buttonUpIsFixed = false;
            }
        },

        openModal() {
            this.$emit('openModal');
        },

        scrollToTop() {
            scrollBy.scrollToTop();
        }
    }
};
</script>
